import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-af7b00dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-paymen" }
const _hoisted_2 = { class: "select-payment-method-component" }
const _hoisted_3 = { style: {"padding":"10px 20px","overflow":"auto"} }
const _hoisted_4 = {
  class: "row",
  style: {"max-height":"calc(705px)"}
}
const _hoisted_5 = {
  class: "col-3",
  style: {"padding":"10px 20px"}
}
const _hoisted_6 = {
  class: "col-3",
  style: {"padding":"10px 20px"}
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { style: {"padding":"10px 10px"} }
const _hoisted_9 = { class: "tableFixHead" }
const _hoisted_10 = { class: "table table-bordered" }
const _hoisted_11 = {
  colspan: "4",
  class: "text-end"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "col-12"
}
const _hoisted_14 = { style: {"padding":"10px 10px"} }
const _hoisted_15 = { class: "tableFixHead" }
const _hoisted_16 = { class: "table table-bordered" }
const _hoisted_17 = {
  colspan: "2",
  class: "text-end"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, null, -1))
const _hoisted_19 = { class: "footer-actions" }
const _hoisted_20 = { class: "button-container text-center" }
const _hoisted_21 = { class: "padding" }
const _hoisted_22 = { class: "pt-3" }
const _hoisted_23 = { class: "section" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "label" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_28 = { class: "buttons d-flex justify-content-between" }
const _hoisted_29 = { class: "padding" }
const _hoisted_30 = { class: "section" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_34 = { class: "buttons d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_view_header = _resolveComponent("view-header")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_OverlayModal = _resolveComponent("OverlayModal")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_view_header, {
      text: _ctx.$t('cashier.shift.closingDayShift')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.shift.startDateTime')) + " " + _toDisplayString(_ctx.initData?.startDateTime), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.shift.user')) + " " + _toDisplayString(_ctx.initData?.openShiftUserFullName), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.shift.cashierId')) + " " + _toDisplayString(_ctx.cashierId), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.shift.totalOrders')) + " " + _toDisplayString(_ctx.initData?.numberOfOrders), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('cashier.shift.totalTickets')) + " " + _toDisplayString(_ctx.initData?.qtyOfSoldTickets), 1),
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('cashier.shift.totalSales')) + " ", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initData?.groupedPayments, (payment, index) => {
                return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(payment.totalAmount) + " " + _toDisplayString(payment.currencyName) + _toDisplayString(index >= 0 && index + 1 != _ctx.initData?.groupedPayments?.length ? ', ' : ''), 1))
              }), 128))
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('cashier.shift.totalOfRefunds')) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_ctx.getTotalAmount(_ctx.initData?.groupedRefundedPayments)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cashier.shift.cashierPaymentSummary')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("table", _hoisted_10, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.paymentMethodType')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.label.currency')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.openingBalance')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.qtyOfTransaction')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.label.amount')), 1),
                      _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.label.balance')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initData?.groupedPayments, (payment, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: 'payment-' + index
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payment.payments, (data, dataIndex) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: 'data-' + dataIndex
                          }, [
                            _createElementVNode("td", null, _toDisplayString(_ctx.getPaymentTypeName(data.paymentType)), 1),
                            _createElementVNode("td", null, _toDisplayString(payment.currencyName), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.getOpenBalance(data.paymentType, payment.currencyId)), 1),
                            _createElementVNode("td", null, _toDisplayString(data.transactionCount), 1),
                            _createElementVNode("td", null, _toDisplayString(data.totalAmount), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.getBalanceSummary(data.paymentType, payment.currencyId, data.totalAmount)), 1)
                          ]))
                        }), 128))
                      ], 64))
                    }), 128))
                  ]),
                  _createElementVNode("tfoot", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_11, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cashier.label.total')), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalAmount(_ctx.initData?.groupedPayments)), 1)
                      ]),
                      _hoisted_12
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.initData?.groupedRefundedPayments?.length ?? 0 > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cashier.shift.cashierPaymentRefunds')), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("table", _hoisted_16, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.dateAndTime')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.paymentMethodType')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.label.amount')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.label.currency')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.qtyOfTransaction')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.receiptId')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.orderNumber')), 1),
                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('cashier.shift.customer')), 1)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initData?.groupedRefundedPayments, (payment, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'payment-' + index
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payment.payments, (data, dataIndex) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: 'data-' + dataIndex
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(data.createdAt), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.getPaymentTypeName(data.paymentType)), 1),
                                  _createElementVNode("td", null, _toDisplayString(data.totalAmount), 1),
                                  _createElementVNode("td", null, _toDisplayString(payment.currencyName), 1),
                                  _createElementVNode("td", null, _toDisplayString(data.transactionCount), 1),
                                  _createElementVNode("td", null, _toDisplayString(data.receiptId), 1),
                                  _createElementVNode("td", null, _toDisplayString(data.orderNumber), 1),
                                  _createElementVNode("td", null, _toDisplayString(data.customerFullName), 1)
                                ]))
                              }), 128))
                            ], 64))
                          }), 128))
                        ]),
                        _createElementVNode("tfoot", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cashier.label.total')), 1)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("strong", null, _toDisplayString(_ctx.getTotalAmount(_ctx.initData?.groupedRefundedPayments)), 1)
                            ]),
                            _hoisted_18
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeShift && _ctx.closeShift(...args))),
            style: {"margin-inline-end":"10px","background":"rgb(4, 98, 152)","color":"white"}
          }, _toDisplayString(_ctx.$t('cashier.shift.closeShift')), 1),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = () => _ctx.isOpenIncorrectBalanceModal = true),
            class: "p-ripple incorrect-btn",
            style: {"margin-inline-end":"10px"}
          }, _toDisplayString(_ctx.$t('cashier.shift.incorrectBalance')), 1),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args))),
            type: "button",
            class: "p-ripple cancel-btn"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
          ])), [
            [_directive_ripple]
          ])
        ])
      ])
    ]),
    _createVNode(_component_OverlayModal, {
      "is-open": _ctx.isOpenClosingShiftModal,
      "modal-width": "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["settings-content", { 'expand': _ctx.isOpenClosingShiftModal }])
            }, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cashier.shift.cantOpenShift')), 1),
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('cashier.shift.pleaseEnterManagerCode')), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('cashier.shift.managerCode')), 1),
                      _createVNode(_component_TextInput, {
                        modelValue: _ctx.managerCode,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.managerCode) = $event)),
                        scope: _ctx.validation.scope,
                        rules: _ctx.validation.rules.required
                      }, null, 8, ["modelValue", "scope", "rules"])
                    ])
                  ])
                ]),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "submit",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeShift && _ctx.closeShift(...args))),
                    class: "p-ripple submit-btn"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('cashier.shift.closeShift')), 1)
                  ])), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpenClosingShiftModal = false)),
                    type: "button",
                    class: "p-ripple cancel-btn"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
                  ])), [
                    [_directive_ripple]
                  ])
                ])
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode(_component_OverlayModal, {
      "is-open": _ctx.isOpenIncorrectBalanceModal,
      "modal-width": "700"
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["settings-content", { 'expand': _ctx.isOpenIncorrectBalanceModal }])
            }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t('cashier.shift.balanceDescription')), 1),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.balanceDescirption) = $event)),
                        class: "form-control"
                      }, "\n                                    ", 512), [
                        [_vModelText, _ctx.balanceDescirption]
                      ])
                    ])
                  ])
                ]),
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "submit",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isOpenIncorrectBalanceModal = false)),
                    class: "p-ripple submit-btn"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.save')), 1)
                  ])), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", {
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.cancelBalanceDesciption && _ctx.cancelBalanceDesciption(...args))),
                    type: "button",
                    class: "p-ripple cancel-btn"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('button.cancel')), 1)
                  ])), [
                    [_directive_ripple]
                  ])
                ])
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}